// extracted by mini-css-extract-plugin
export default {"filterContainer":"filters-module--filter-container--jPAL4"};